module.exports = __webpack_public_path__ + "assets/img/fdf7-lb.svg";